import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import Input from '../../../../components/Form/Input';
import { snackbar } from '../../../../utilities/snackbarUtils'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { numberRegMatch } from '../../../../constants/blockchain';
import SubmitButton from '../../../../components/Form/SubmitButton';
import { errorParser } from '../../../../components/LiquidForm/utils/errorParser';
import burnAsset from '../../../../api/blockchain/burnAsset';

const BurnDialog = (props) => {
    const theme = useTheme();

    const schema = yup.object({
        amount: yup
            .string()
            .required('Please enter the amount to burn.')
            .matches(
                numberRegMatch,
                'Please enter a valid amount.'
            )
            .nullable()
    });

    const defaultValues = {
        amount: ''
    }

    const { handleSubmit, control, reset, formState: { isSubmitting, errors }, } = useForm({
        resolver: yupResolver(schema),
        defaultValues: defaultValues,
    });

    const onSubmit = async (data) => {
        // console.log(data)
        await burnAsset({ asset_uuid: props.asset?.assetUuid, ...data }).then(response => {
            snackbar.success('Asset burning started. It should complete in ~2 minutes.');
            reset(defaultValues);
            props.handleClose()
            props.updateAssets()
        }).catch((error) => {
            snackbar.error(errorParser(error));
        })
    };

    return (
        <Dialog open={props.open} onClose={props.handleClose}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>Burn {props.asset?.name} ({props.asset?.ticker})</DialogTitle>
                <DialogContent>
                    <div style={{ display: 'flex', color: theme.palette.text.secondary }}>
                        <Typography variant='body2'>
                            Destroy an asset amount
                        </Typography>
                    </div>
                    <br />
                    <Input
                        name='amount'
                        error={errors?.amount}
                        control={control}
                        label='Amount'
                        placeholder='0'
                        numeric
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handleClose}>Cancel</Button>
                    <SubmitButton 
                        text='Burn'
                        disabled={isSubmitting}
                        loading={isSubmitting}
                    />
                </DialogActions>
            </form>
        </Dialog>
    )
}

export default BurnDialog